/* Smooth scroll — ported from the design's SiteHeader (Lenis). Wheel only: touch keeps native scrolling.
   Pauses whenever the page is locked (drawers, pop-ups, lightbox, cart apps) and lets scrollable panels scroll on their own. */
(function () {
  var H = document.documentElement, B = document.body;
  if (!window.Lenis || window.__yuumaLenis) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  // Touch screens scroll natively; Lenis's touch listeners only get in the way there (and block swipes while stopped).
  if (window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
  var duration = parseFloat(H.getAttribute('data-smooth-scroll')) || 1.3;

  function scrollsOnItsOwn(node) {
    for (var n = node; n && n !== B && n !== H; n = n.parentElement) {
      if (n.hasAttribute && n.hasAttribute('data-lenis-prevent')) return true;
      var oy = getComputedStyle(n).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && n.scrollHeight > n.clientHeight + 1) return true;
    }
    return false;
  }

  var lenis = new window.Lenis({
    duration: duration,
    easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
    smoothWheel: true,
    anchors: { offset: -120 },
    prevent: scrollsOnItsOwn
  });
  window.__yuumaLenis = lenis;
  function raf(t) { lenis.raf(t); requestAnimationFrame(raf); }
  requestAnimationFrame(raf);

  // Stop while anything locks the page (theme sets overflow:hidden on <html>; apps often lock <body>).
  var stopped = false;
  function sync() {
    var locked = H.style.overflow === 'hidden' || getComputedStyle(B).overflow === 'hidden' || getComputedStyle(H).overflowY === 'hidden' && !H.classList.contains('lenis-stopped');
    if (locked && !stopped) { stopped = true; lenis.stop(); }
    else if (!locked && stopped) { stopped = false; lenis.start(); }
  }
  new MutationObserver(sync).observe(H, { attributes: true, attributeFilter: ['style', 'class'] });
  new MutationObserver(sync).observe(B, { attributes: true, attributeFilter: ['style', 'class'] });
  // Re-check while stopped, in case an app unlocks the page without touching <html>/<body> attributes.
  setInterval(function () { if (stopped) sync(); }, 1000);
})();
